import "./Header.scss";
import { Link } from "react-router-dom";
import { Notification, User } from "../";
import useLogout from "../../hooks/useLogout";
import { useNavigate } from "react-router-dom";

import { ReactComponent as LogoIcon } from "../../assets/images/logo.svg";
import LogoIconRetargeo from "../../assets/images/retargeo-logo-black.jpg";
import { ReactComponent as ExitIcon } from "../../assets/images/exit.svg";
import useUser from "../../data/useUser";
import { useState, useEffect } from "react";

export default function Header() {
  const logout = useLogout({ onlyUserToken: true });
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const {
    user: {
      user_balance: { score, personal_account },
      signup_domain,
    },
  } = useUser();
  function numberWithSpaces(number) {
    if(number < 10000) return number
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  }
  function formatPersonalAccount(account) {
    if (account === undefined || account === null) return "000000";
    const accountString = String(account);
    return accountString.length < 6 ? accountString.padStart(6, "0") : accountString;
  }
  return (
    <header className="Header">
      <div className="header-container">
        <Link className="icon" to="/">
          {signup_domain === 'lk.retargeo.ru' ? <img width={220} style={{ marginTop: 10 }} src={LogoIconRetargeo} className="logo" alt="" /> : <LogoIcon className="logo" />}
        </Link>

        <div className="profile">
          <div className="wrapp" style={{ cursor: 'pointer' }} onClick={() => navigate('/balance')}>
            <div
              className="balance"
              style={{
                textWrap: "nowrap",
                borderRight: "1px solid rgba(66, 69, 76, 0.1)",
                paddingRight: isMobile ? 10 : 22,
                marginRight: isMobile ? 10 : 22,
              }}
            >
              л/с: {formatPersonalAccount(personal_account)}
            </div>
            <div className="balance">Баланс:</div>
            <div style={{ textWrap: "nowrap", fontSize: isMobile ? 14 : 16, color: score < 0 ? '#e55656' : '#3f73f9' }} className="sum">{numberWithSpaces(score) ?? 0} ₽</div>
          </div>

          {false && <Notification />}

          <User />

          <div className="exit">
            <button type="button" onClick={logout}>
              <ExitIcon />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
